import { defineI18nConfig } from "#i18n";
import de from "./lang/de-DE.json";
import en from "./lang/en-EN.json";
import es from "./lang/es.json";
import fr from "./lang/fr-FR.json";
import it from "./lang/it-IT.json";
export default () => ({
	legacy: false,
	locale: "es",
	fallbackLocale: "es",
	messages: {
		de,
		en,
		es,
		fr,
		it
	}
});
